import { styled, css } from '@creditas-ui/system';

const navTextExpanded = ({ expanded = false }: { expanded?: boolean }) =>
  expanded &&
  css`
    width: auto;
    align-self: flex-start;
    margin: 0 auto;
  `;

export const IconLogoWrapper = styled.div`
  overflow: hidden;
  transition: width 1.265s ease-out;
  background: #fff;
  padding: 5px;
  width: 56px;
  height: 56px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 5000px;
  & > svg {
    transform: scale(0.75);
  }
  ${navTextExpanded}
`;
